import React from 'react';
import ProjectSitePreview from './ProjectSitePreview';
import LmsPreviewMock from './LmsPreviewMock';

/** Portfolio card preview — live site screenshot or LMS product mock */
const ProjectCardPreview = ({ project, height, frameless = false }) => {
  if (project.useLmsPreview) {
    return <LmsPreviewMock height={height} domain={project.domain} frameless={frameless} />;
  }

  return (
    <ProjectSitePreview
      liveUrl={project.links?.live}
      previewImage={project.previewImage}
      domain={project.domain}
      title={project.title}
      icon={project.icon}
      gradient={project.gradient}
      height={height}
      frameless={frameless}
    />
  );
};

export default ProjectCardPreview;
